import React, { Fragment } from "react";
import { Card, Col, CardBody } from "reactstrap";
import HeaderCard from "../../Common/HeaderCard";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { ContainerStyle, DefaultCenter } from "../../../Data/Map/GoogleMap";

const CustomMarker = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAjeJEPREBQFvAIqDSZliF0WjQrCld-Mh0",
  });
  return (
    <Fragment>
      <Col xl="6" md="12">
        <Card>
          <HeaderCard title={"Custom Marker"} />
          <CardBody>
            <div className="react-simple-map-container">{isLoaded ? <GoogleMap mapContainerStyle={ContainerStyle} center={DefaultCenter} zoom={10}></GoogleMap> : "loading"}</div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default CustomMarker;
